<div (click)="onClick()">
  <div #selector class="multilevel-selector" [ngClass]="{'multilevel-selector-disabled':user.roleId === 4}">
    <!-- || oneTreeNode}"> -->
    <div class="multilevel-selector-head"
      [ngClass]="{'multilevel-selector-head-opened':showDropdown,'custom-place-holder':!selection.hasValue()}"
      (click)="toogleDropdown()">
      <div *ngIf="excludedSingleType()">
        <span>
          {{multilevelSelectorHeadNumber > 1 ? '('+multilevelSelectorHeadNumber+')' : ''}}
          {{(multilevelSelectorHead ? multilevelSelectorHead : 'DATATABLE.FILTERS.ENTITY') | translate}}
        </span>
        <span *ngIf="clearSelectorPB && !oneTreeNode" (click)="clear($event)" title="Clear all">×</span>
      </div>
      <div *ngIf="includedSingleType()">
        <span *ngIf="typeData !== 'analyticPackages'" >
          {{multilevelSelectorHead | translate}}
        </span>
        <span *ngIf="typeData === 'analyticPackages'" >
          {{multilevelSelectorHeadNumber > 1 ? '('+multilevelSelectorHeadNumber+')' : ''}}
          {{(multilevelSelectorHead ? multilevelSelectorHead : 'DATATABLE.FILTERS.ENTITY') | translate}}
        </span>
        <span *ngIf="typeData === 'analyticPackages' && (allSelected !== undefined && !allSelected)" (click)="clear($event)" title="Clear all">×</span>
      </div>

    </div>
    <div *ngIf="showDropdown" class="multilevel-selector-dropdown">
      <div class="multilevel-selector-dropdown-search-container">
        <input #inputSearch type="search" class="form-control" [placeholder]="'DATATABLE.SEARCH' | translate"
          [(ngModel)]="selectorSearch" (ngModelChange)="onChange($event,'search')" (keyup)="applyFilters()"
          [ngModelOptions]="{standalone: true}">
      </div>
      <!--<div class="multi-level-item">
      <input id="entity-multilevel-item-{{ i }}" type="checkbox" [(ngModel)]="item!.selected"
          (change)="change($event,item)" />
      <span (click)="toogle(item)">{{item.target.name}}</span>
  </div>-->

      <cdk-virtual-scroll-viewport itemSize="48" class="tree-viewport">
        <div *cdkVirtualFor="let node of visibleNodes" class="tree-node"
          [style.paddingLeft.px]="node.level >=0 ? (node.level * 20)+adminWraper : 0">
          <div>
            <div
              *ngIf="[2, 3].includes(node['entityTypeId']) && ['package','usersList', 'devicesList', 'entitiesList','settingsList'].includes(typeData)"
              class="toogle-all" (click)="toggleAll($event,node)" [title]="'COMMON.ALL'| translate"></div>
            <!--[ngClass]="{'toogle-all-selected':node.allSelected}"-->
            <div [class.reassign-no-device-hidden]="typeData === 'reassignNoDevice' && node['entityTypeId'] === 2">
              <mat-checkbox [disabled]="disableCheck(node)" [checked]="selection.isSelected(node)"
                (change)="toggleSelection(node)">
              </mat-checkbox>
            </div>
            <div (click)="toggleNode(node)" class="tree-node-content">
              <div>
                <div *ngIf="node['entityTypeId'] !== 2 && node['entityTypeId'] !== 1"
                  class="multilevel-selector-tree-node-item-flag"
                  [style.background]="node['entityTypeId'] === 4 ? 'green' : node['entityTypeId'] === 3 ? 'orange' : 'black'">
                </div>
                <div>
                  <div [style.textDecoration]="ckeckIncludeSelected(node) ? 'underline' : 'unset'" [title]="node.name">
                    {{ node.name
                    }}{{configSvc.currentConfigValue.debug ? '('+node.id+')' : ''}}</div>
                </div>
              </div>
              <!--<div *ngIf="search?.length && node['parentEntity']['type'] >= 2">
              <div class="multilevel-selector-tree-node-item-flag"
                [style.background]="node['parentEntity']['type'] === 4 ? 'green' : node['parentEntity']['type'] === 3 ? 'orange' : 'black'">
              </div>
              <div>{{ node['parentEntity']['name'] }}</div>
            </div>-->
            </div>
            <!--<button *ngIf="node.expandable" >
          {{ node.expanded ? '📂' : '📁' }}
        </button>-->
            <mat-icon *ngIf="node.expandable && node.children.length" class="mat-icon-rtl-mirror" mat-icon-button
              (click)="toggleNode(node)" [ngClass]="{'icon-expanded':node.expanded}">chevron_right
              <!--{{ node.expanded ? 'expand_more' : 'chevron_right' }}-->
            </mat-icon>
          </div>
          <div *ngIf="search?.length && !node['level']">
            <div *ngIf="node['entityTypeId'] === 3 && node['parentEntity']" class="multilevel-selector-tree-node-item-flag"
              [style.background]="node['parentEntity']?.entityTypeId === 4 ? 'green' : node['parentEntity']?.entityTypeId === 3 ? 'orange' : node['parentEntity']?.entityTypeId === 2 ? 'black' : ''">
            </div>
            <div *ngIf="node['entityTypeId'] === 4 && node['parentEntity']" class="multilevel-selector-tree-node-item-flag"
              [style.background]="node['parentEntity']?.entityTypeId === 4 ? 'green' : node['parentEntity']?.entityTypeId === 3 ? 'orange' : node['parentEntity']?.entityTypeId === 2 ? 'black' : ''">
            </div>
            <div *ngIf="node['entityTypeId'] >= 2 && node['parentEntity']" class="multilevel-selector-labels-item-rot">
              {{node['parentEntity']?.name}}</div>
          </div>

        </div>
      </cdk-virtual-scroll-viewport>
    </div>
    <div *ngIf="showDropdown && selection.selected.length && excludedSingleType()" class="multilevel-selector-labels">
      <div
        *ngFor="let item of (typeData !== 'gazeMaps' && typeData !=='fits' ? selection.selected : onlyOpticals()); index as i">
        <div class="multilevel-selector-labels-item">
          <div>
            <div>
              <div *ngIf="item['entityTypeId'] >= 2 " class="multilevel-selector-labels-item-flag"
                [style.background]="item['entityTypeId'] === 4 ? 'green' : item['entityTypeId'] === 3 ? 'orange' : 'black'">
              </div>
              <div>{{item.name}}</div>
            </div>
            <div>
              <div *ngIf="item['entityTypeId'] === 3 && item['parentEntity']" class="multilevel-selector-labels-item-flag"
                [style.background]="item['parentEntity']?.entityTypeId === 4 ? 'green' : item['parentEntity']?.entityTypeId === 3 ? 'orange' : item['parentEntity']?.entityTypeId === 2 ? 'black' : ''">
              </div>
              <div *ngIf="item['entityTypeId'] === 4 && item['parentEntity']" class="multilevel-selector-labels-item-flag"
                [style.background]="item['parentEntity']?.entityTypeId === 4 ? 'green' : item['parentEntity']?.entityTypeId === 3 ? 'orange' : item['parentEntity']?.entityTypeId === 2 ? 'black' : ''">
              </div>
              <div *ngIf="item['entityTypeId'] >= 2 && item['parentEntity']" class="multilevel-selector-labels-item-rot">{{item['parentEntity']?.name}}</div>
            </div>
          </div>
          <div class="multilevel-selector-labels-item-close-pb"><i class="bi bi-x" (click)="deselect(item)"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>